export default __webpack_public_path__ + "static/superbetter-development-web-14b38315ea30360f13a9819a0e03bc6b.webp";